const article = document.querySelector('article .articles__content');
if(!article) return;


function addIdToHeading(targetText) {
  // Select all heading elements
  const headings = article.querySelectorAll('h1, h2, h3, h4, h5, h6');

  headings.forEach(heading => {
      // Extract text content without tags
      const text = heading.textContent.trim();

      if (text.includes(targetText)) {
          // Create an ID-friendly version of the text
          const id = targetText.replace(/\s+/g, '_'); // Replace spaces with underscores
          heading.id = id;
      }

      heading.classList.add('anchor-offset');
  });
}


const contentList = article.querySelector('ol');
Array.from(contentList.querySelectorAll('li')).forEach(li => {
  const idText = li.textContent.replace(/\s+/g, '_'); // Convert text to an anchor-friendly format
  const anchor = document.createElement('a'); // Create anchor element
  anchor.href = `#${idText}`; // Set anchor link
  anchor.textContent = li.textContent; // Preserve original text
  document.getElementById(idText)?.classList.add('anchor-offset');

  li.innerHTML = ''; // Clear existing content
  li.appendChild(anchor); // Append anchor inside <li>

  addIdToHeading(li.textContent);
});


